export default __webpack_public_path__ + "serato.71bc0d4d.png";